import { ROUTES } from 'Utils/constants'

export const CUSTOMER_DISPLAY_SUPPORTED_ROUTES = [
  ROUTES.createQuote,
  ROUTES.editQuoteHeaderId,
  ROUTES.generateQuote,
  ROUTES.quoteProduct,
]

export const isCustomerDisplayRouteSupported = pathname =>
  CUSTOMER_DISPLAY_SUPPORTED_ROUTES.some(route => pathname.includes(route))
